import { Folder } from '@/api/generatedApi';
import { useDownloadArchive } from '@/hooks/useDownloadArchive';
import { Download as DownloadIcon } from '@mui/icons-material';
import { IconButton, IconButtonProps, Tooltip } from '@mui/material';

export const DownloadFolderButton = ({
  folder,
  size = 'small',
}: {
  folder: Folder;
  size?: IconButtonProps['size'];
}) => {
  const { downloadArchive, isPending } = useDownloadArchive();

  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    downloadArchive({ folderIds: [folder.id] });
  };

  return (
    <Tooltip title='Download folder'>
      <span>
        <IconButton onClick={handleClick} size={size} disabled={isPending}>
          <DownloadIcon sx={{ fontSize: '22px' }} />
        </IconButton>
      </span>
    </Tooltip>
  );
};
